import script from "./GoodsListDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./GoodsListDialog.vue?vue&type=script&setup=true&lang=js"

import "./GoodsListDialog.vue?vue&type=style&index=0&id=7249acec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7249acec"]])

export default __exports__